import React from "react";
/**
 * 防抖组件
 *
 * 用于避免无用重渲染
 *
 * @author 张卓诚
 * @export
 * @class Debounce
 * @extends {React.PureComponent<{selected: string; children(selected: string): React.ReactNode}>}
 */
export class Debounce extends React.PureComponent {
    render() {
        if (this.props.children && this.props.selected) {
            return this.props.children(this.props.selected);
        }
        return null;
    }
}
//# sourceMappingURL=debonce.js.map